import React from 'react';
import Image from 'next/image';
import styles from './WhatWeDo.module.scss';
import Reveal from 'react-awesome-reveal';
import { flipFromLeft, flipFromRight } from '../Animation/Animation';
import { Typography } from '../Typography';

const WhatWeDo = () => {
  const productCapabilities = [
    'Video plugin frameworks for professional editing platforms',
    'High-performance graphics and video processing tools',
    'Cross-platform software systems with optimized performance',
    'GPGPU and hardware-accelerated solutions',
    'Product configuration and technical guidance for complex production pipelines',
  ];

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.leftSection}>
          <Reveal keyframes={flipFromLeft} duration={1000} delay={100} triggerOnce>
            <div className={styles.imageWrapper}>
              <Image
                src="/about/what-we-do.jpg"
                alt="What We Do"
                width={1024}
                height={1024}
                layout="responsive"
              />
            </div>
          </Reveal>
        </div>
        <div className={styles.rightSection}>
          <Reveal keyframes={flipFromRight} duration={1000} delay={200} triggerOnce>
            <div className={styles.iconWrapper}>
              <div className={styles.icon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 17.5H3.5M6.5 12H2M9 6.5H4M17 3L10.4036 12.235C10.1116 12.6438 9.96562 12.8481 9.97194 13.0185C9.97744 13.1669 10.0486 13.3051 10.1661 13.3958C10.3011 13.5 10.5522 13.5 11.0546 13.5H16L15 21L21.5964 11.765C21.8884 11.3562 22.0344 11.1519 22.0281 10.9815C22.0226 10.8331 21.9514 10.6949 21.8339 10.6042C21.6989 10.5 21.4478 10.5 20.9454 10.5H16L17 3Z" stroke="#E9D7FE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <Typography variant="display-sm" as="h2" color="grayDark-50" weight="semibold" className={styles.heading}>
              What We Do
            </Typography>
            <Typography variant="text-lg" color="grayDark-600" className={styles.intro}>
              At EPEN, we design and develop product-focused solutions, including:
            </Typography>
            <ul className={styles.servicesList}>
              {productCapabilities.map((capability, index) => (
                <li key={index} className={styles.serviceItem}>
                  <div className={styles.checkIcon}>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 3L4.5 8.5L2 6" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <Typography variant="text-lg" color="grayDark-600" className={styles.serviceText}>
                    {capability}
                  </Typography>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </div>
  );
};

export default WhatWeDo;
